import { Button, Space, message } from 'antd'
import { useToken } from 'app/hooks'
import React from 'react'
import API from 'utils/api'

const SaveGroup = ({ data,mutate }) => {
	const { data: token } = useToken()
	return (
		<Space.Compact>
			<Button
				type="primary"
				size="small"
				onClick={() => {
					const postdata = {
						name: data?.name,
						info_d: data?.info_d,
						info_w: data?.info_w,
						cs_1: data?.cs_1,
						cs_2: data?.cs_2,
						cs_3: data?.cs_3,
						cs_4: data?.cs_4,
						kor_1: data?.kor_1,
						kor_2: data?.kor_2,
						kor_3: data?.kor_3,
						seq: data?.seq,
						parentid: data?.parentid
					};

					console.log(postdata)

					API.send(
						'PUT',
						'/admin/usergroup/' + data?.id,
						token + '',
						postdata
					).then(res => {
						mutate(1)
						message.success('그룹 정보 저장 완료')
					})
				}}>
				저장
			</Button>
		</Space.Compact>
	)
}

export default SaveGroup
